const DraftStatusIcon = ({
  width = 11,
  height = 11,
  color = "currentColor",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 11 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M5.5 7.79199H6.1875' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M5.5 10.083H6.1875' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M5.5 0.916992H6.1875' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M8.02087 10.0833H8.70837C8.82993 10.0833 8.94651 10.035 9.03246 9.94909C9.11842 9.86314 9.16671 9.74656 9.16671 9.625' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M8.02087 0.916992H8.70837C8.82993 0.916992 8.94651 0.965281 9.03246 1.05123C9.11842 1.13719 9.16671 1.25377 9.16671 1.37533V2.06283' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M9.16671 6.41699V7.79199H8.02087' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M9.16663 3.89551V4.58301' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M1.83337 4.58301V3.89551' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M1.83337 8.93783V6.41699' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M1.83337 2.06283C1.83337 1.75893 1.9541 1.46748 2.16898 1.2526C2.38387 1.03771 2.67531 0.916992 2.97921 0.916992H3.66671' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M3.66671 10.0837H2.97921C2.67531 10.0837 2.38387 9.96294 2.16898 9.74805C1.9541 9.53317 1.83337 9.24172 1.83337 8.93783C1.83337 8.63393 1.9541 8.34248 2.16898 8.1276C2.38387 7.91271 2.67531 7.79199 2.97921 7.79199H3.66671' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default DraftStatusIcon;
